import { defineMessages } from 'react-intl';
import { GENERAL_SERVICES_NAMES } from '../names/_generalServices.names';

const intlPrefix =
  'app.dealer.account.DealerProfileSettings.ServicesPanel.services.intl.generalServices';

/**
 * @typedef {import('../names/_generalServices.names').GENERAL_SERVICES_NAMES} GeneralServicesNames
 * @typedef {Record<GeneralServicesNames, {id: string, defaultMessage: string}>} GeneralServicesNamesIntl
 */

/**
 * `defineMessages` is used by `react-intl`. It is just a function that returns the object it's passed.
 * `react-intl` needs it to comply with babel-plugin-react-intl and i18n message extraction.
 *
 * @description
 * general services intl text
 *
 * @const generalServicesIntl
 * @type {GeneralServicesNamesIntl}
 */
export const generalServicesIntl = defineMessages({
  [GENERAL_SERVICES_NAMES.SERVICE_24_HOURS]: {
    id: `${intlPrefix}.service24Hours`,
    defaultMessage: '24-Stunden-Service',
  },
  [GENERAL_SERVICES_NAMES.TOWING_SERVICE]: {
    id: `${intlPrefix}.towingService`,
    defaultMessage: 'Abschleppdienst',
  },
  [GENERAL_SERVICES_NAMES.CAR_REPLACEMENT_SERVICE]: {
    id: `${intlPrefix}.carReplacementService`,
    defaultMessage: 'Ersatzwagen-Service',
  },

  [GENERAL_SERVICES_NAMES.EXPRESS_SERVICE]: {
    id: `${intlPrefix}.expressService`,
    defaultMessage: 'Express-Service',
  },
  [GENERAL_SERVICES_NAMES.VEHICLE_PREPARATION_INT]: {
    id: `${intlPrefix}.vehiclePreparationInt`,
    defaultMessage: 'Fahrzeugaufbereitung (innen)',
  },
  [GENERAL_SERVICES_NAMES.VEHICLE_PREPARATION_EXT]: {
    id: `${intlPrefix}.vehiclePreparationExt`,
    defaultMessage: 'Fahrzeugaufbereitung (außen)',
  },
  [GENERAL_SERVICES_NAMES.CAR_RENTAL]: {
    id: `${intlPrefix}.carRental`,
    defaultMessage: 'Fahrzeugvermietung',
  },
  [GENERAL_SERVICES_NAMES.VEHICLE_REGISTRATION]: {
    id: `${intlPrefix}.vehicleRegistration`,
    defaultMessage: 'Fahrzeugzulassung',
  },
  [GENERAL_SERVICES_NAMES.COLLECTION_AND_DELIVERY_SERVICE]: {
    id: `${intlPrefix}.collectionAndDeliveryService`,
    defaultMessage: 'Hol- & Bring-Service',
  },
  [GENERAL_SERVICES_NAMES.MASTER_WORKSHOP]: {
    id: `${intlPrefix}.masterWorkshop`,
    defaultMessage: 'Meisterwerkstatt',
  },
  [GENERAL_SERVICES_NAMES.BREAKDOWN_SERVICE]: {
    id: `${intlPrefix}.breakdownService`,
    defaultMessage: 'Pannenhilfe',
  },
  [GENERAL_SERVICES_NAMES.TIRE_STORAGE]: {
    id: `${intlPrefix}.tireStorage`,
    defaultMessage: 'Reifen (Einlagerung)',
  },
  [GENERAL_SERVICES_NAMES.TIRE_SALE]: {
    id: `${intlPrefix}.tireSale`,
    defaultMessage: 'Reifen (Verkauf)',
  },
  [GENERAL_SERVICES_NAMES.ORIGINAL_VEHICLE_PARTS]: {
    id: `${intlPrefix}.originalVehicleParts`,
    defaultMessage: 'Original-Fahrzeugteile',
  },
  [GENERAL_SERVICES_NAMES.ACCIDENT_ASSISTANCE]: {
    id: `${intlPrefix}.accidentAssistance`,
    defaultMessage: 'Unfallhilfe',
  },
  [GENERAL_SERVICES_NAMES.SALE_OF_ACCESSORIES]: {
    id: `${intlPrefix}.saleOfAccessories`,
    defaultMessage: 'Verkauf von Zubehör',
  },
});
